import React from 'react';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
import WhatsAppButton from '../common/ActionButton/WhatsAppButton';
import MailButton from '../common/ActionButton/MailButton';
import DownloadButton from '../common/ActionButton/DownloadButton';
import '../../style/PageTable.css';
import { deleteEntity } from '../../utlis/deleteEntity';
import { API_BASE } from '../../config';
import { getStatus } from '../../utlis/sellerStatus';

const RegisteredTable = ({ sellers, onRowClick, onSellerDeleted, onEditClick }) => {
  const columns = [
    { header: 'ID', key: 'id', style: { width: '60px' }},

  { header: 'Name', key: 'name', style: { width: '160px' }},

  { header: 'Company', key: 'companyName', style: { width: '220px' }},

  { header: 'Contact', key: 'contact', style: { width: '200px' }},

  { header: 'State', key: 'state', style: { width: '120px' }},

  { header: 'Package', key: 'package', style: { width: '160px' }},

  { header: 'Subscription', key: 'subscription', style: { width: '140px' }},

  { header: 'Status', key: 'status', style: { width: '110px' }},

  { header: 'Actions', className: 'actions-header', style:{width:'170px'}}
  ];

  const handleDeleteSeller = async (seller, event) => {
    event.stopPropagation();
    await deleteEntity({
      entityType: 'vcseller',
      entityId: seller.id,
      onDeleted: onSellerDeleted,
      event: event,
      confirmationMessage: `Are you sure you want to delete seller ${seller.firstName} ${seller.lastName}?`
    });
  };

  const handleDownloadInvoice = async (seller, event) => {
    event.stopPropagation();
    if (seller.taxInvoicePath) {
      // The taxInvoicePath is the S3 URL (publicly accessible due to public-read ACL)
      const url = seller.taxInvoicePath;
      
      try {
        // Fetch the file directly - S3 file is public-read, no auth needed
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error('Failed to download invoice');
        }
        
        const blob = await response.blob();
        
        // Get filename from the seller's taxInvoiceName or use default
        let filename = seller.taxInvoiceName || `tax_invoice_${seller.id}.pdf`;
        
        // Create download link
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error('Error downloading invoice:', error);
        alert('Failed to download invoice. Please try again.');
      }
    } else {
      alert('No tax invoice available for this seller');
    }
  };

  const renderRow = (seller) => (
    <>
      <td>{seller.id}</td>
      <td>{seller.firstName} {seller.lastName}</td>
      <td>{seller.companyName}</td>
      <td>{seller.phoneNumber}<br />{seller.emailID}</td>
      {/* <td>{seller.phoneNumber}</td> */}
      {/* <td>{seller.emailID}</td> */}
      <td>{seller.state}</td>
      {/* <td>{seller.gst}</td> */}
      <td>
        {seller.package
          ? `${seller.package} - ${seller.years} ${
              seller.years === 1 ? 'year' : 'years'
            }`
          : '-'}
      </td>
      <td>{seller.startDate} to {seller.endDate}</td>
      {/* <td>{seller.endDate}</td> */}
      <td>
        <span
          style={{
            backgroundColor: getStatus(seller.endDate) === 'Expired' ? '#dc3545' : '#28a745',
            color: 'white',
            padding: '4px 12px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 'bold',
            display: 'inline-block'
          }}
        >
          {getStatus(seller.endDate)}
        </span>
      </td>

      <td className="actions-cell">
        <EditButton
          onClick={(e) => {
            e.stopPropagation();
            onEditClick(seller);
          }}
          className="seller-edit-btn"
          title="Edit Seller"
        />
        {seller.phoneNumber && (
          <WhatsAppButton
            className="whatsapp-btn"
            title="Send WhatsApp message"
            phone={seller.phoneNumber}
          />
        )}
        {seller.emailID && (
          <MailButton
            className="mail-btn"
            title="Send Email"
            email={seller.emailID}
          />
        )}
        {seller.taxInvoicePath ? (
          <DownloadButton
            onClick={(e) => handleDownloadInvoice(seller, e)}
            className="download-btn"
            title="Download Tax Invoice"
          />
        ) : (
          <span style={{ fontSize: '11px', color: '#999', padding: '0 4px' }}>No Invoice</span>
        )}
        <DeleteButton
          title="Delete Seller"
          className="delete-btn"
          onClick={(e) => handleDeleteSeller(seller, e)}
        />
      </td>
    </>
  );

  return (
    <Table
      columns={columns}
      data={sellers}
      renderRow={renderRow}
      className="page-table"
      onRowClick={onRowClick ? (seller) => onRowClick(seller.id) : undefined}
    />
  );
};

export default RegisteredTable;
